import axios, { HttpStatusCode } from 'axios';
import { PropsWithChildren } from 'react';
import { useNavigate } from 'react-router-dom';
import { logger } from '@trading-utils/logger';
import { getAuthToken } from '@trading-utils/sso-cognito';

import { apiRoutes } from '../../config/apiRoutes';
import { appRoutes } from '../../config/appRoutes';

export default function AxiosWrapper({ children }: PropsWithChildren) {
  const navigate = useNavigate();
  const { ERROR_401, ERROR_403 } = appRoutes;

  axios.interceptors.request.use(async (config) => {
    if (config?.url?.startsWith(`${apiRoutes.base}`)) {
      try {
        const token = await getAuthToken();
        if (token) {
          // eslint-disable-next-line no-param-reassign
          config.headers.Authorization = `Bearer ${token}`;
        }
      } catch (error) {
        logger.error('Error getting auth token', { error });
      }
    }
    return config;
  });

  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response) {
        if (!window.location.href.includes(ERROR_401) && !window.location.href.includes(ERROR_403)) {
          switch (error.response.status) {
            case HttpStatusCode.Unauthorized:
              navigate(ERROR_401);
              break;
            case HttpStatusCode.Forbidden:
              navigate(ERROR_403);
              break;
            default:
              break;
          }
        }
      }
      return Promise.reject(error);
    }
  );
  return children;
}
